import React, { useEffect, useState } from 'react';

import styles from './Slider.module.css'
import {Slide} from "./types/slide.interface.ts";
import {arrowLeftIcon, arrowRightIcon} from "../../../assets/icons/icons.ts";
import {cn} from "../../../utils/cn.ts";

interface Props {
    slides: Slide[];
    slidesToShow: number;
    autoTimer?: number;
}

export const Slider: React.FC<Props> = ({ slides, slidesToShow, autoTimer }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!autoTimer) {
            return;
        }

        const timer = setInterval(next, autoTimer);

        return () => clearInterval(timer);
    }, [autoTimer, slides.length]);

    function navigate(direction: 'prev' | 'next'): void {
        const step = 1

        const shouldRestart = (currentIndex + slidesToShow) === slides.length;
        if (shouldRestart) {
            setCurrentIndex(0)

            return;
        }

        if ('next' === direction) {
            setCurrentIndex(currentIndex + step)
        } else {
            setCurrentIndex(currentIndex - step)
        }
    }

    function next(): void {
        navigate('next')
    }

    function prev(): void {
        navigate('prev')
    }
    function calcTranslate(): string {
        return `-${(100 / slidesToShow) * currentIndex}%`;
    }

    return (
        <div className={styles.container}>
            <button className={cn(styles.btn, styles.btnPrev)} onClick={prev}>
                <img className={styles.icon} width={18} height={28} src={arrowLeftIcon} alt='Следующий отзыв'/>
            </button>
            <div className={styles.wrapper}>
                <div className={styles.track}
                     style={{
                         transform: `translateX(${calcTranslate()})`,
                     }}
                >
                    {slides.map((slide) => (
                        <div
                            className={styles.slide}
                            key={slide.id}
                            style={{
                                flex: `0 0 ${100 / slidesToShow}%`,
                            }}
                        >
                            {slide.content}
                        </div>
                    ))}
                </div>
            </div>
            <button className={cn(styles.btn, styles.btnNext)} onClick={next}>
                <img className={styles.icon} width={18} height={28} src={arrowRightIcon} alt='Следующий отзыв'/>
            </button>
        </div>
    );
};